/**
 * Adressage stable d'un ecart, pour une URL partageable (P4.1).
 *
 * L'URL designe la **cle suivie** — code article, ou identifiant de famille — et
 * non l'identifiant de l'ecart. Un ecart solde puis reapparu change de ligne, et
 * donc d'identifiant : un lien envoye par courriel cesserait d'ouvrir quoi que
 * ce soit. La cle, elle, traverse les imports sans bouger.
 *
 * Les deux mailles partagent le meme espace d'adresses, d'ou le prefixe : un
 * identifiant de famille est un UUID, un code article une suite de chiffres —
 * ils ne se confondent pas, mais le prefixe rend la lecture immediate et evite
 * d'avoir a deviner la maille pour interroger la base.
 */
/** Ce qui distingue une famille d'un article dans une adresse. */
export const PREFIXE_FAMILLE = 'famille-';
/**
 * Caracteres admis dans une cle. Volontairement etroit : un segment d'URL mal
 * recopie ne doit pas ouvrir une fiche au hasard, ni traverser un chemin.
 */
const CLE_VALIDE = /^[A-Za-z0-9_.:@+-]{1,80}$/;
/** Segment d'URL d'un ecart, tel qu'il apparait dans `/ecarts/<segment>`. */
export function adresseEcart(maille, cle) {
    return maille === 'FAMILLE' ? `${PREFIXE_FAMILLE}${cle}` : cle;
}
/** Relecture d'un segment d'URL. `null` si ce n'est pas une adresse d'ecart. */
export function lireAdresseEcart(segment) {
    const brut = segment.trim();
    if (brut.startsWith(PREFIXE_FAMILLE)) {
        const cle = brut.slice(PREFIXE_FAMILLE.length);
        return CLE_VALIDE.test(cle) ? { maille: 'FAMILLE', cle } : null;
    }
    return CLE_VALIDE.test(brut) ? { maille: 'ARTICLE', cle: brut } : null;
}
//# sourceMappingURL=discrepancy-address.js.map